var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileIgtvTimerBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 146,
  height: 3,
  viewBox: "0 0 146 3",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 146,
  height: 3,
  fill: "#FFF",
  fillOpacity: 0.4,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 73,
  height: 3,
  fill: "#FEFFFF",
  rx: 1.5
}))));
export default SvgInstagramMobileIgtvTimerBar;